import fetch from '@/utils/fetch'
// 意见反馈
export function feedback (data) {
  return fetch({
    url: '/feed/back',
    method: 'post',
    data
  })
}
// 应用列表
export function appList (params = {}) {
  return fetch({
    url: '/app/list',
    method: 'get',
    params: {
      searchName: params.searchName,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 设置应用文件默认保存位置
export function setUserApp (data) {
  return fetch({
    url: '/app/user/set',
    method: 'post',
    data
  })
}
// 应用详情
export function appInfo (params = {}) {
  return fetch({
    url: '/app/user/set/info/' + params.app_number,
    method: 'get',
    params: {
      app_number: params.app_number,
      group_number: params.group_number,
    }
  })
}
// 客户端发布版本更新列表
export function clientReleases (params) {
  return fetch({
    url: '/client/releases',
    method: 'get',
    params: {
      offset: params.offset,
      limit: params.limit,
      terminal_type: params.terminal_type
    }
  })
}
// 【公开图片上传】
export function publicFileUpload (data) {
  return fetch({
    url: '/publicFileUpload',
    method: 'post',
    data
  })
}
// 系统配置信息
export function info () {
  return fetch({
    url: '/info',
    method: 'get'
  })
}
// 系统通知接口（发布系统服务维护的通知信息）
export function newslist () {
  return fetch({
    url: '/newslist',
    method: 'get'
  })
}